var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4116 6.07571C14.4116 8.52324 12.4492 10.4858 9.99992 10.4858C7.5515 10.4858 5.58826 8.52324 5.58826 6.07571C5.58826 3.62819 7.5515 1.6665 9.99992 1.6665C12.4492 1.6665 14.4116 3.62819 14.4116 6.07571ZM9.99992 18.3332C6.38523 18.3332 3.33325 17.7457 3.33325 15.479C3.33325 13.2115 6.4044 12.6448 9.99992 12.6448C13.6154 12.6448 16.6666 13.2323 16.6666 15.499C16.6666 17.7665 13.5954 18.3332 9.99992 18.3332Z",
    fill: "#CFC8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3a911240ad818524641f9995c1c3fe4e.svg";
export { ForwardRef as ReactComponent };